// 9fbef606107a605d69c0edbcd8029e5d 
const common = {
  white: '#fff',
  black: '#000',
  purple: '#b976cc',
  newpurple: '#C7389C',
  venmoBorder: '#2c2e2f',
};

export default common;
